import gql from "graphql-tag";

export default gql`
  query getCurrentPurchaseExposure($query: QueryInput, $offset: OffsetInput) {
    getCurrentPurchaseExposure(query: $query, offset: $offset) {
      source
      purchase_id
      deal_id
      property_id
      property_name
      lease_id
      ownership_as_of
      is_owned
      ownership_needs_review
      ownership_reasons
      equity_currency
      purchase_equity_native
      sale_equity_native
      remaining_equity_native
      owned_equity_native
      owned_equity_usd
      noi_currency
      fund_ownership {
        fund_id
        fund_name
        funding_ids
        allocation_share
        purchase_equity_native
        sale_equity_native
        remaining_equity_native
        owned_equity_native
        owned_equity_usd
        currency
        is_owned
        ownership_needs_review
        ownership_reasons
        disposition_date
      }
      date: purchase_date
      currency
      native_price
      native_noi
      price_usd
      noi_usd
      fx_rate
      fx_date
      fx_missing
      tenant_parsekey
      guarantor_parsekey
      security_parsekey
      is_vacant
      lease_end_date
      lease_date_needs_review
      property_type
      property_geo_code
      buildings
      square_feet
      master_lease
    }
  }
`;
